<div
	[innerHTML]="url | svg | async"
	[ngStyle]="{ height: cssSize(height), width: cssSize(width) }"
	class="{{class}}"></div>
